import actionTypes from 'SRC/modules/redux/actionTypes'
import initialState from 'SRC/modules/redux/initialState'

export const brandsReducer = (state = initialState.ads.brands, action) => {
  switch (action.type) {
    case actionTypes.SET_BRANDS:
      return {
        ...state,
        elements: action.payload
      }
    default:
      return state
  }
}
